var ErrorChanel = /*#__PURE__*/function (ErrorChanel) {
  ErrorChanel["QA"] = "qa";
  ErrorChanel["CONTENT"] = "content";
  return ErrorChanel;
}(ErrorChanel || {});
class BaseError extends Error {}
class Error404 extends BaseError {
  constructor(url) {
    super('404 Page');
    this.chanel = ErrorChanel.QA;
    this.type = '404';
    this.name = '404 Page';
    this.url = url;
  }
}
class MissingTranslateError extends BaseError {
  constructor(key) {
    super('Missing translate: ' + key);
    this.chanel = ErrorChanel.QA;
    this.type = 'translate';
    this.name = 'Translations';
    this.key = key;
  }
}

/**
 * Generated bundle index. Do not edit.
 */

export { BaseError, Error404, ErrorChanel, MissingTranslateError };
